import { useRoute } from "wouter";

import { FetcherResult } from "../api-client/fetcher";
import { ModifiedSWRResponse, useSwrGet } from "../api-client/useSwrGet";
import {
  DealerChassisResultsRoute,
  DealerVinResultsRoute,
} from "../navigation/DealerRoutes";
import { useVehicleModelIdParam } from "../stores/useVehicleModelIdParam";
import {
  TireSize,
  VehicleColourCode,
  VehicleHasMappedParts,
} from "./useGetVehicleInfoByVehicleKeys";

export const useGetVehicleInfoByChassis = (): ModifiedSWRResponse<
  FetcherResult<VehicleInfoByChassisPayload>,
  VehicleInfoByChassisPayload
> => {
  const [isChassisRoute, chassisParams] = useRoute(DealerChassisResultsRoute);
  const [isVinRoute, vinParams] = useRoute(DealerVinResultsRoute);
  const dealerId = chassisParams?.dealerId ?? vinParams?.dealerId ?? "";
  const vehicleChassis =
    chassisParams?.vehicleChassis ?? vinParams?.vehicleVin ?? "";
  const [vehicleModelId] = useVehicleModelIdParam();

  const result = useSwrGet<VehicleInfoByChassisPayload>(
    isChassisRoute || isVinRoute
      ? "/retailSiteWebService/vehicle/getVehicleInfoByVehicleChassis.php"
      : null,
    {
      dealerId,
      vehicleChassis,
      vehicleModelId,
    }
  );

  return result;
};

export type VehicleInfoByChassisPayload = {
  decodedVehicle?: DecodedVehicle;
  modelCandidates?: VinModelCandidate[];
  vehicleColourCodes: VehicleColourCode[];
  vehicleFullTireSizeInfo: TireSize[];
  vehicleHasMappedParts: VehicleHasMappedParts;
  vehicleId: string;
  vehicleOriginalTiresize: TireSize | null;
};

export type DecodedVehicle = {
  make: string;
  matchedModelName?: string;
  model: string;
  vehicleManufacturerId?: number;
  vehicleModelId?: number;
  vehicleYearId?: number;
  year: number;
};

export type VinModelCandidate = {
  vehicleModelId: number;
  vehicleModelName: string;
};

/**
 * @see docs/worklog/TW-967-hunter-vin-results-vehicle-tire-sizes/rca.md
 * @see docs/worklog/TW-967-hunter-vin-results-vehicle-tire-sizes/rfc.md
 * @see docs/worklog/TW-967-hunter-vin-results-vehicle-tire-sizes/tfc.md
 */
